import axios from "axios";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

export const getSuggestionData = async (searchTerm: string, indicies: string[], esApiKey: JwtTokenFn, language: string) => {
    const indiciesString = indicies.join(",");
    const apiKey = await esApiKey();

    const url = `${EnvironmentConfig.elasticSearchProxyUrl}/${indiciesString}/_search`;

    return axios.post(
        url,
        {
            query: {
                bool: {
                    minimum_should_match: 1,
                    should: [
                        {
                            match_phrase: {
                                [`possible_user_question_${language}`]: searchTerm,
                            }
                        },
                        {
                            match_phrase_prefix: {
                                [`possible_user_question_${language}`]: {
                                    query: searchTerm,
                                }
                            }
                        },
                        {
                            term: {
                                [`possible_user_question_${language}`]: searchTerm,
                            }
                        }
                    ],
                    must_not: [
                        {
                            term: {
                                chunk_type: "original_document",
                            },
                        },
                        {
                            term: {
                                chunk_type: "semantic_enriched",
                            },
                        },
                        {
                            term: {
                                type: "content",
                            },
                        },
                    ],
                },
            },
        },
        {
            headers: {
                Authorization: `Bearer ${apiKey}`,
            },
        }
    )
        .then((response) => {
            const res = response.data.hits.hits.map((hit: any) => {
                return { possible_user_question: hit._source[`possible_user_question_${language}`] }
            });
            return res;
        })
        .catch((error) => {
            console.error("Fetch Error :-S", error);
            return error;
        });
}

export const getQuestionData = async (searchTerm: string, indicies: string[], esApiKey: JwtTokenFn, language?: string) => {
    const indiciesString = indicies.join(",");
    const apiKey = await esApiKey();

    const url = `${EnvironmentConfig.elasticSearchProxyUrl}/${indiciesString}/_search`;

    return axios.post(
        url,
        {
            query: {
                bool: {
                    minimum_should_match: 1,
                    should: [
                        {
                            match_phrase: {
                                [`suggestion_${language}`]: searchTerm,
                            }
                        },
                        {
                            match_phrase_prefix: {
                                [`suggestion_${language}`]: {
                                    query: searchTerm,
                                }
                            }
                        },
                        {
                            match: {
                                [`suggestion_${language}`]: searchTerm,
                            }
                        }
                    ],
                    must_not: [
                        {
                            term: {
                                chunk_type: "original_document",
                            },
                        },
                        {
                            term: {
                                chunk_type: "semantic_enriched",
                            },
                        },
                        {
                            term: {
                                type: "content",
                            },
                        },
                    ],
                },
            },
        },
        {
            headers: {
                Authorization: `Bearer ${apiKey}`,
            },
        }
    )
        .then((response) => {
            const filteredHits = response.data.hits.hits.filter((hit: any) => language && hit._source?.[`suggestion_${language}`]);
            return filteredHits.map((hit: any) => ({ title: hit._source[`suggestion_${language}`] }));
            // if (!language) return [];
            // const filteredHits = response.data.hits.hits.filter((hit: any) => language && hit._source?.t?.question[language]);
            // return filteredHits.map((hit: any) => ({title: hit._source.t.question[language]}));
        })
        .catch((error) => {
            console.error("Fetch Error :-S", error);
            return error;
        });
};
